import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

export const Paragraph = styled.p`
  font-size: 1.125rem;
  font-weight: bold;
  margin: 8px 0 0 0;
`;

export const Counter = styled.div`
  ${({ theme }) => css`
    font-size: 3rem;
    color: ${theme.darkTheme.colors.green};
  `}
`;
